export default {
  title: 'Hole dir die beste Erfahrung mit unserer mobilen App',
  description: 'Spare Zeit, verdiene Belohnungen und erhalte Benachrichtigungen über noch mehr Angebote und mehr',
  buttons: {
    download: 'Öffne die {{name}} App',
  },
};
